import React from 'react'
import { Icon, Label, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import utils from '../../../../../utils'

export default class ReserveDriverButton extends React.PureComponent {
  state = {
    assigning: false,
    removing: false,
  }

  assigning = async () => {
    try {
      const { order, readOnly } = this.props

      if (readOnly) return

      const conf = window.confirm('Are you sure to request to reserved driver?')

      if (conf) {
        this.setState({ assigning: true })

        const params = {
          orderUid: order.key,
          driverUid: order.reserve_driver,
        }

        const functions = firebase
          .app()
          .functions('asia-northeast1')
          .httpsCallable('orderAction')

        await functions({ actionType: 'assign-driver', ...params })

        this.setState({ assigning: false })
      }
    } catch (error) {
      this.setState({ assigning: false })
      alert(error.message || error)
    }
  }

  removing = async () => {
    try {
      const { order, readOnly } = this.props

      if (readOnly) return

      this.setState({ removing: true })

      const params = {
        orderUid: order.key,
        driverUid: order.reserve_driver,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'remove-reserve-driver', ...params })

      this.setState({ removing: false })
    } catch (error) {
      this.setState({ removing: false })
      alert(error.message || error)
    }
  }

  render() {
    const { order, driver, finding, showReserve, readOnly } = this.props
    const { assigning, removing } = this.state

    if (order.reserve_driver && driver) {
      const driverName = `${driver.family_name} ${driver.first_name}`
      const isAssignable = driver.status === 'available' && driver.online

      const isDisabled = assigning || removing
      const onRemove = () => !isDisabled && this.removing()
      const onAssign = () => !isDisabled && isAssignable && this.assigning()
      const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(driver.tel)

      return (
        <div>
          <div>
            <strong>{driverName}</strong>
          </div>

          <div>
            <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
              <Label style={{ marginTop: 5, width: 120 }}>{order.reserve_driver}</Label>
            </a>
          </div>

          <div>
            <Button
              disabled={isDisabled || readOnly}
              size="mini"
              color="yellow"
              style={{ width: 120, margin: 0, marginTop: 5 }}
              onClick={showReserve}
            >
              Reserved
            </Button>
          </div>

          <div>
            <Icon
              color="red"
              name={removing ? 'spinner' : 'cancel'}
              loading={removing}
              disabled={isDisabled || readOnly}
              style={{ cursor: 'pointer', margin: 5 }}
              onClick={onRemove}
            />
            <Icon
              color={isAssignable ? 'green' : 'grey'}
              name={assigning ? 'spinner' : 'arrow right'}
              loading={assigning}
              disabled={isDisabled || !isAssignable || readOnly}
              style={{ cursor: 'pointer', margin: 5 }}
              onClick={onAssign}
            />
          </div>
        </div>
      )
    }

    return (
      <Button
        size="mini"
        icon="bookmark"
        content="Reserve"
        onClick={showReserve}
        labelPosition="right"
        disabled={finding || readOnly}
        style={{ width: 120, margin: 0, marginTop: 5 }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/ReserveDriver.js